import React, { useCallback } from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import MapMode from "@app/scene/map/enums/MapMode";
import { exitLassoMode } from "@app/scene/map/store/actions";
import { getMapMode } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

import styles from "./ExitLassoModeButton.module.scss";

const messages = defineMessages({
  backToGroup: {
    id: "map.recordsList.backToGroup",
    defaultMessage: "Back to Group",
    description: "Records list - Back to Group",
  },
});

interface Props {
  className?: string;
  exitLassoMode: typeof exitLassoMode;
  label?: React.ReactNode;
  mapMode?: MapMode;
  onClick?: () => void;
}

const ExitLassoModeButton: React.FC<Props> = ({ className, exitLassoMode, label, onClick }) => {
  const intl = useIntl();

  const handleBackToGroup = useCallback(() => {
    exitLassoMode();
    onClick?.();
  }, [exitLassoMode, onClick]);

  return (
    <div className={cn(styles.container, className)}>
      <Button className={styles.btn} onClick={handleBackToGroup}>
        &larr;
        <span className={styles.btnLabel}>{label ?? intl.formatMessage(messages.backToGroup)}</span>
      </Button>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  mapMode: getMapMode(state),
});

const mapDispatchToProps = {
  exitLassoMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExitLassoModeButton);
